import styled from '@emotion/styled';
import { oldTheme } from '../shared/old-styles';

export const RSecondTitle = styled.div`
  ${oldTheme.fontWeight.bold};
  color: ${oldTheme.darkGray};
  font-size: ${oldTheme.fontSize.xl};
  margin-bottom: ${oldTheme.spacing.s};
`;
